
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HasRoleDirective } from './app-has-role.directive';
import { SubmitButtonDirective } from './submit-button.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [HasRoleDirective, SubmitButtonDirective],
  exports: [HasRoleDirective, SubmitButtonDirective]
})
export class CustomDirectivesModule {}
